Cureus.UserPicker = {};

//= require_tree ./UserPicker
